import Animation from './animation'
import * as d3 from 'd3-selection'

/*
 * This animation is used when a new slice (i.e. serie) is removed to a pie chart
 */
class ExitingAnimation extends Animation {

  match (serie) {
    return this.seriesChanged && // Series changed
           this.exitingSeries.selection().data().indexOf(serie) !== -1 // this serie is part of the exiting selection
  }

  animate (serie, entering, selection, merged, exiting) {
    let prev = this.previousPies
      , arc = this.arc
      , self = this

    this.exitingSeries
        .filter(f => f.id === serie.id) // Get the exiting serie
        .selectAll('use')
        .call(this.fadeOut)
        .select(d => {
          let path = d3.select(`#${d.pathUid.id}`)
                       .transition()
                       .duration(exiting.duration()) // Can't inherit transitions since the use references a different parent
            , to = Object.assign({}, path.node()._current)

          if (to.index) {
            let prevPie = self.getPie(d.rangeId, prev)
              , prevSerieId = prevPie.slices[to.index - 1].data.serieId
              , newPie = self.getPie(d.rangeId)
              , newSerie = newPie.slices.find(slice => slice.data.serieId == prevSerieId)

            to.startAngle = newSerie.endAngle
            to.endAngle = newSerie.endAngle
          } else {
            to.endAngle = to.startAngle // Goto 0
          }

          path.attrTween('d', this.arcTweener(path.node(), to))
        })
  }

}

export default ExitingAnimation
